import Comment from '@/models/Comment';
import PurchaseOrder from '@/models/PurchaseOrder';
import PurchaseOrderService from '@/services/PurchaseOrderService';
import { defineStore } from 'pinia';
import { useRepo } from 'pinia-orm';

export const usePurchaseOrdersStore = defineStore('purchaseOrders', {
  state: () => ({}),

  getters: {
    models: () => useRepo(PurchaseOrder),
  },

  actions: {
    async fetchPurchaseOrders(projectId: Id, params: ApiRequests['api.v1.purchase-orders.index'] = {}) {
      const [data, error] = await PurchaseOrderService.index(projectId, params);

      if(error) {
        throw error;
      }

      this.models.save(data.data);

      return data;
    },

    async fetchPurchaseOrder(id: Id) {
      const [data, error] = await PurchaseOrderService.show(id);

      if(error) {
        throw error;
      }

      this.models.save(data.data);

      return data;
    },

    async createPurchaseOrder(projectId: Id, form: ApiRequests['api.v1.purchase-orders.store'] | FormData) {
      const [data, error] = await PurchaseOrderService.create(projectId, form);

      if(error) {
        throw error;
      }

      this.models.save(data);

      return data;
    },

    async updatePurchaseOrder(id: Id, form: ApiRequests['api.v1.purchase-orders.update']) {
      const [data, error] = await PurchaseOrderService.update(id, form);

      if(error) {
        throw error;
      }

      this.models.save(data);

      return data;
    },

    async deletePurchaseOrder(id: Id) {
      const [data, error] = await PurchaseOrderService.destroy(id);

      if(error) {
        throw error;
      }

      this.models.destroy(id);

      return data;
    },

    async markPaid(id: Id) {
      const [data, error] = await PurchaseOrderService.markPaid(id);

      if(error) {
        throw error;
      }

      this.models.save(data);

      return data;
    },

    async cancelPurchaseOrder(id: Id) {
      const [data, error] = await PurchaseOrderService.cancel(id);

      if(error) {
        throw error;
      }

      this.models.save(data);

      return data;
    },

    async media(id: Id) {
      const [data, error] = await PurchaseOrderService.media(id);

      if(error) {
        throw error;
      }

      return data;
    },

    async storeMedia(id: Id, form: ApiRequests['api.v1.purchase-orders.media.store'] | FormData) {
      const [data, error] = await PurchaseOrderService.storeMedia(id, form);

      if(error) {
        throw error;
      }

      return data;
    },

    async comment(id: Id, form: ApiRequests['api.v1.purchase-orders.comments']) {
      const [data, error] = await PurchaseOrderService.comment(id, form);

      if(error) {
        throw error;
      }

      const comments = useRepo(Comment);

      comments.save(data);

      return data;
    },
  },
});
